export default __webpack_public_path__ + "static/media/2_0022.52233247.webp";